var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtrudedSurface20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x80\x9A\xE7\x94\xA8\xE5\x9B\xBE\xE6\xA0\x87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1234",
    x: 0.625,
    y: -0.625,
    width: 10,
    height: 18.75,
    transform: "matrix(1 0 0 -1 0 18.75)",
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1236",
    d: "M11.25 0H14.5312L20 20H11.25V0Z",
    fill: "#222627"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtrudedSurface20);
export default __webpack_public_path__ + "static/media/extruded-surface_20.6e49c5c8f7b78470d67f22f93f27ed7e.svg";
export { ForwardRef as ReactComponent };